<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { SwitchRoot, SwitchThumb } from "reka-ui"
import { cn } from "@/lib/utils"

// reka-ui 2.x changed the SwitchRoot API: checked → modelValue, update:checked → update:modelValue.
// This wrapper keeps the stable checked/update:checked surface used throughout the app
// (mirrors Checkbox.vue).
const props = defineProps<{
  checked?: boolean
  defaultChecked?: boolean
  disabled?: boolean
  required?: boolean
  name?: string
  id?: string
  class?: HTMLAttributes["class"]
}>()

const emits = defineEmits<{
  "update:checked": [value: boolean]
}>()
</script>

<template>
  <SwitchRoot
    :id="props.id"
    :model-value="props.checked"
    :default-value="props.defaultChecked"
    :disabled="props.disabled"
    :required="props.required"
    :name="props.name"
    :class="cn(
      'peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-state data-[state=unchecked]:bg-input',
      props.class,
    )"
    @update:model-value="emits('update:checked', !!$event)"
  >
    <SwitchThumb
      :class="cn('pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5')"
    >
      <slot name="thumb" />
    </SwitchThumb>
  </SwitchRoot>
</template>
